import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient';

 interface HistoryLogsParams {
  user_id?: number;
  platform_id?: number;
  content_type_id?: number;
  changed_at_max?: string;
  changed_at_min?: string;
  page?: number;
  page_size?: number;
  category?: string;
  search_param ?: string;
  changed_at ?: string;
  changed_by ?: number;
}

const buildQueryString = (params: HistoryLogsParams = {}) => {
  const queryParts: string[] = [];
  if (params.user_id !== undefined) queryParts.push(`user_id=${params.user_id}`);
  if (params.platform_id !== undefined) queryParts.push(`platform_id=${params.platform_id}`);
  if (params.changed_by !== undefined) queryParts.push(`changed_by=${params.changed_by}`);
  if (params.content_type_id !== undefined) queryParts.push(`content_type_id=${params.content_type_id}`);
  if (params.category !== undefined) queryParts.push(`category=${params.category}`);
  if (params.changed_at_max) queryParts.push(`changed_at_max=${encodeURIComponent(params.changed_at_max)}`);
  if (params.changed_at_min) queryParts.push(`changed_at_min=${encodeURIComponent(params.changed_at_min)}`);
  if (params.search_param !== undefined) queryParts.push(`search_param=${params.search_param}`);
  if (params.changed_at !== undefined) queryParts.push(`changed_at=${params.changed_at}`);
  if (params.page !== undefined) queryParts.push(`page=${params.page}`);
  if (params.page_size !== undefined) queryParts.push(`page_size=${params.page_size}`);

  return queryParts.length ? `?${queryParts.join("&")}` : "";
};

export const fetchHistoryLogsAsync = createAsyncThunk(
  '/market_connect/setting-change-history',
  async (params: HistoryLogsParams = {}, toolkit) => {
    const queryString = buildQueryString(params);
    const endpoint = `/setting-change-history${queryString}`;

    return await AxiosClient('GET', endpoint, {}, toolkit, {}, toolkit.signal);
  }
);

export const getModuleListAsync = createAsyncThunk( 
  '/market_connect/setting-change-history/content-types',
  async (params : any, toolkit) => {
    const endpoint = `/setting-change-history/content-types`;
    return await AxiosClient('GET', endpoint, {}, toolkit, {}, toolkit.signal);
  }
);
export const getChangedByUserListAsync = createAsyncThunk( 
  '/market_connect/setting-change-history/changed-by-users',
  async (params : { user_id: number }, toolkit) => {
    const endpoint = `/setting-change-history/changed-by-users?user_id=${params.user_id}`;
    return await AxiosClient('GET', endpoint, {}, toolkit, {}, toolkit.signal);
  }
);
